import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import DesktopHeader from '../../components/Header/DesktopHeader/DesktopHeader';
import { GO_LOGIN } from '../../../store/actions/auth.types';
import DesktopHeader from '../../components/Header/DesktopHeader/DesktopHeader';
import DesktopNav from '../../components/Nav/DesktopNav/DesktopNav';
import DesktopQuickLinks from '../../components/Nav/DesktopNav/DesktopQuickLinks';
import ShadowSeparator from '../../components/UI_Elements/ShadowSeparator';
import DesktopFooter from '../../components/Footer/DesktopFooter/DesktopFooter';
import DesktopRealTalk from '../../components/Footer/DesktopFooter/DesktopRealTalk';
import styles from './DesktopLayout.css';


// isLoggedIn shows the registered login
const DesktopLayout = props => {
  let isPrintPage = props.isPrintPage;
  return (
  <div className={styles.layout}>
    {!isPrintPage && <DesktopHeader {...props} />}
    {!isPrintPage && <DesktopNav {...props} />}
    {!isPrintPage && <ShadowSeparator />}
    {!isPrintPage && <DesktopQuickLinks {...props} />}
    {props.children}
    {!props.isLoggedIn && !props.loginView && <DesktopRealTalk {...props} /> }
    {!isPrintPage && <DesktopFooter {...props} />}
  </div>
)};

DesktopLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  loginView: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isLoggedIn: state.auth.loggedIn,
  loginView: state.location.type === GO_LOGIN,
});

export default connect(mapStateToProps)(DesktopLayout);



// WEBPACK FOOTER //
// ./src/app/Layout/DesktopLayout/DesktopLayout.js